export default __webpack_public_path__ + "static/media/star-empty.6284e3f9.svg";